import { LogOut } from 'lucide-react';
import { useAuthStore } from 'store';
import { Button } from 'components/ui/Button';
import { CardHeader } from 'components/ui/card';

export default function AppHeader() {
  const user = useAuthStore((state) => state.user);
  const stationId = useAuthStore((state) => state.stationId);
  const logout = useAuthStore((state) => state.logout);

  const userDisplay = user?.name || user?.email || user?.id || '';

  return (
    <CardHeader className="flex-row items-center justify-between gap-3 space-y-0 pb-4">
      <div className="min-w-0 flex-1">
        <div className="truncate text-base font-semibold text-slate-800">{userDisplay}</div>
        <div className="mt-1 text-sm text-slate-500">Station {stationId || ''}</div>
      </div>
      <Button
        onClick={() => {
          void logout();
        }}
        variant="destructive"
        size="sm"
        className="h-10 rounded-xl px-4"
      >
        <LogOut className="h-4 w-4" />
        Logout
      </Button>
    </CardHeader>
  );
}
